import { buildSlice, CommonState } from '~libs/reduxUtils';

import { PricePlan } from '~support-at-home/models';

import { getAll, getOne, typePrefix } from '~support-at-home/actions/pricePlans';

const initialState: CommonState<PricePlan> = {
  loading: 'idle',
  hasLoaded: false,
  error: null,
  rows: [],
  total: 0,
};

const slice = buildSlice<CommonState<PricePlan>, PricePlan>(typePrefix, initialState, {
  commonConfig: { getOne },
  customActions: {
    clearPlan(state) {
      state.row = undefined;
    },
    clearErrors(state) {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAll.fulfilled, (state, action) => {
      state.rows = action.payload.data;
      state.total = action.payload.total;
      state.loading = 'fulfilled';
      state.hasLoaded = true;
    });
  },
});

export const { clear, clearPlan, updateParams, clearErrors } = slice.actions;
export default slice.reducer;
